import type {
  AdminReportListItem,
  AdminReportListResult,
  AdminShouttDetail,
  AdminShouttListResult,
  AiFlaggedKind,
  AiFlaggedListResult,
  ReportListParams,
  ShouttListParams,
} from '@/types/moderation.types';
import { cleanParams } from '@/utils/params.util';

import { apiClient } from './api.service';

export const moderationApi = {
  listShoutts: (params: ShouttListParams = {}) =>
    apiClient
      .get<AdminShouttListResult>('/admin/shoutts', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  getShoutt: (id: string) =>
    apiClient.get<AdminShouttDetail>(`/admin/shoutts/${id}`).then((r) => r.data),

  approveShoutt: (id: string) =>
    apiClient.post<AdminShouttDetail>(`/admin/shoutts/${id}/approve`).then((r) => r.data),

  rejectShoutt: (id: string, reason?: string) =>
    apiClient
      .post<AdminShouttDetail>(`/admin/shoutts/${id}/reject`, reason ? { reason } : {})
      .then((r) => r.data),

  removeShoutt: (id: string) =>
    apiClient.post<AdminShouttDetail>(`/admin/shoutts/${id}/remove`).then((r) => r.data),

  restoreShoutt: (id: string) =>
    apiClient.post<AdminShouttDetail>(`/admin/shoutts/${id}/restore`).then((r) => r.data),

  listReports: (params: ReportListParams = {}) =>
    apiClient
      .get<AdminReportListResult>('/admin/reports', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  getReport: (id: string) =>
    apiClient.get<AdminReportListItem>(`/admin/reports/${id}`).then((r) => r.data),

  resolveReport: (id: string, note?: string) =>
    apiClient
      .post<AdminReportListItem>(`/admin/reports/${id}/resolve`, note ? { note } : {})
      .then((r) => r.data),

  listAiFlagged: (params: { page?: number; limit?: number } = {}) =>
    apiClient
      .get<AiFlaggedListResult>('/admin/moderation/ai-flagged', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  dismissAiFlag: (kind: AiFlaggedKind, id: string) =>
    apiClient.post<null>('/admin/moderation/ai-flagged/dismiss', { kind, id }).then((r) => r.data),

  removeAiFlagged: (kind: AiFlaggedKind, id: string) =>
    apiClient.post<null>('/admin/moderation/ai-flagged/remove', { kind, id }).then((r) => r.data),

  rescan: () =>
    apiClient.post<{ queued: number }>('/admin/moderation/rescan').then((r) => r.data),
};
